import Avatar from 'react-avatar';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import aboutUsDiscussion from '../assets/img/about-us-discussion.png';
import aboutUsLaptop from '../assets/img/about-us-laptop.png';
// import LeftBehindBGImg from '../assets/img/new-design/left-behind.png';
import { makeAnEnquiry } from 'utils/handler';
import Jeffrey from '../assets/users/user_jeff.png';
import { ContributedDomains, FirstFooter, WhyChooseSaw } from './components/CommonPages';

export const About: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>About Us - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <div className=" about-us-page">
        <div className="ash-bg overflow-hide">
          <div className=" container d-flex justify-content-center  flex-column">
            <div className="row">
              <div className=" col-lg-6 col-md-12">
                <span className="b-title fs-36 ">The Brokerage Firm That’s Changing The Domain Game</span>
                <p className="mt-3">
                  We’re passionate about digital assets here at <span className="f-bolder">Saw.com</span>. It’s our mission to create a transparent environment where you know what’s happening with every step of your domain sale or acquisition (and secure the best possible price!)
                </p>
                <button className="mt-3 btn-grad btn " onClick={() => makeAnEnquiry()}>
                  {t('Make An Inquiry')}
                </button>
                <div className="help-content">
                  <ContributedDomains smallSection={true} />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 d-flex justify-content-center">
                <img className="about-us-laptop" src={aboutUsLaptop} alt="aboutUsDiscussion2" />
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-5 text-center mb-5">
          <div className="why-saw-container ">
            <div className="row text-center why-choose-saw">
              <div className="col-lg-6 col-md-12   ">
                <img className="why-saw-img" src={aboutUsDiscussion} alt="aboutUsDiscussion" />
              </div>
              <div className="col-lg-6 col-md-12  text-left  saw-info our-saw-disc ">
                <div className="sub-title mb-0">This Is a Revolutionary Approach To Domain Acquisition</div>
                <div className="normal-font">
                  <p>Now more than ever, owning a premium domain is a key part of your organization’s digital strategy and brand identity. Trouble is, the current process is often made vague and complex by the so-called ‘expert’ domain brokerage firms.</p>
                  <p>Saw.com does things differently. We help you attract, convert and retain customers through a quality .com domain - without the stress. Our experts make the acquisition process 100% transparent and ensure you never pay a cent more than you need to.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container mt-5 text-center mb-5">
                <div className="why-saw-container ">
                    <div className="row text-center why-choose-saw">
                        <div className="col-lg-6 col-md-12  text-left  saw-info ">
                            <div className="title mb-0">We Practice What We Preach</div>
                            <div className='sub-title mt-0'>That’s Why We’re Called Saw.com</div>
                            <div className="normal-font">
                                <p>Choosing the right domain is easier said than done - and there’s a lot to consider. We’re living proof that a short, memorable, easy to spell, and positive-sounding domain can transform your business for the better. Our team of expert domain consultants are ready to help you do exactly that.                                    </p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12   ">
                            <img className="why-saw-img" src={aboutUsDiscussion2} alt="aboutUsDiscussion2" />
                        </div>
                    </div>
                </div>
            </div> */}
        <div className="  ash-bg mt-5 ">
          <div className=" container text-center ">
            <div className="title">
              <span className="">A Message From Our CEO, Jeffrey Gabriel</span>
            </div>
            <div>
              <Avatar size={'150'} textSizeRatio={3} round={true} src={Jeffrey} name={'Jeffrey Gabriel'} />
            </div>
            <div className="">
              <div className="fw-500 fs-20 m-4">Hi - Jeff here, CEO of Saw.com.</div>
              <div className="w105 fs-16">
                <p className="mt-1">If there’s one thing you need to know about our company, it’s this. We’re changing the way you think about domain trading and doing everything we can to help businesses like yours be seen and create a more powerful online presence. We’re here to get you the impact you deserve.</p>
                <p className="mt-3 about-saw-middle">How good are we at it? Well, our team has contributed to more than $500m in domain transactions and my experience includes a VP of Sales role at Uniregistry where I contributed to $350m in blockbuster domain sales. I held the Guinness World Record for highest domain sale of a .com (sex for $13m) and a .org (poker for $1m).</p>
                <p className="mt-3">Through the experience of me and my colleagues, Saw.com was created to help your business create a powerful online presence. We handle everything for you - just contact our Brokers and we’ll guide you step by step through the entire process. </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <button className="mt-4 btn-grad btn " onClick={makeAnEnquiry}>
                {t('Make An Inquiry')}
              </button>
            </div>
          </div>
        </div>
        <div className="why-saw-container container text-center">
          <div className="title">Why Choose Saw.com To Facilitate & Execute Your Premium Domain Sales & Acquisitions?</div>
          <WhyChooseSaw />
        </div>
        <FirstFooter />

        {/* <div className="ash-bg left-behind text-white row ">
        <img alt="" className="left-behind-img" src={sellStatIllustration}></img>
        <div className="  text-center">
          <StatisticsDetails />
          <div className="row justify-content-center">
            <button className="mt-3 btn-grad btn " onClick={() => makeAnEnquiry()}>
              {t('Make An Inquiry')}
            </button>
          </div>
        </div>
      </div>
       */}
      </div>{' '}
    </>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(About);
